import {Component, OnInit} from '@angular/core';
import {NgxIndexedDBService} from "ngx-indexed-db";
import {IndexedDBConstants} from "./shared/constants/indexedDBConstants";
import {firstValueFrom, Observable} from "rxjs";
import {LoadingService} from "./core/services/loading.service";

/**
 * Main app component.
 */
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    title = 'PIDB';
    isLoading$: Observable<boolean>;

    constructor(private indexedDbService: NgxIndexedDBService, private loadingService: LoadingService) {
        this.isLoading$ = this.loadingService.isLoading$;
    }

    async ngOnInit(){
        firstValueFrom(this.indexedDbService.getAll(IndexedDBConstants.oldDocument)).catch(() => {
            this.indexedDbService.createObjectStore({
                store: IndexedDBConstants.oldDocument,
                storeConfig: {keyPath: 'name', autoIncrement: false},
                storeSchema: []
            })
        });
    }
}
